module.exports = {
  customer: 'wakefield',
  environment: 'production',
  isBetterCare: true,
  jobsVolunteering: false,
  googleAnalyticsId: 'G-94F9E8WKPX',
  robots: false,
  chatWidget: false,
  entitledToBaseUrl: 'https://wakefieldbettercare.entitledto.co.uk',
  entitledToReassessUrl: 'https://wakefieldbettercare.entitledto.co.uk/reassessbetteroff',
  requirePostcode: false,

  app: {
    home: 'https://wakefield.bettercare.org.uk'
  },
  serverBaseUrl: 'https://api-wakefield.bettercare.org.uk',
  api: {
    baseUrl: 'https://api-wakefield.bettercare.org.uk/internal/v1'
  },
  authGateway: 'https://account.wakefield.bettercare.org.uk',
  loginServices: [
    {name: 'kerp'},
    {name: 'phone'},
    {name: 'google', postLogoutUrl: 'https://accounts.google.com/Logout'},
    {name: 'facebook'},
    {name: 'agent'},
    {name: 'referenceNumber'}
  ],
  ui: {
    showJobSearchJournal: false,
    showOfflineForms: true,
    showTestingTools: true,
    showAssessmentMutators: false,
    showDraftForms: true,
    restrictions: {
      applications: false
    }
  },
  airbrake: {
    enabled: true,
    projectId: 131082,
    projectKey: 'facc9a060872b357453b677f15d319e3'
  }
};
